module.exports = __webpack_public_path__ + "static/img/bookDefault.76442b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bookDefault.png
// module id = +WaX
// module chunks = 2